<template>
  <div class="dealer_manage_list">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <address-book v-model="addressData" :config="configData" :isbutton="true" v-if="isShowByPermission('/wyms/bussiness/insertBusinessNumber')">添加用户</address-book>
      <el-button size="medium" type="danger" @click="deleteSelectHandler" v-if="isShowByPermission('/wyms/bussiness/deleteBusinessNumber')">移出用户</el-button>
    </div>
    <div class="dealer_content">
      <el-table @select="selectionChangeHandler" @select-all="selectionChangeHandler" border :height="windowHeight - 160" :data="dataList" style="width: 100%">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="loginname" label="账号" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="gender" label="性别">
          <template slot-scope="scope">
            <span>{{sexList[scope.row.gender] || '未知'}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="mobile" label="手机号" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandler(scope.row.userId)">移出</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
  import AddressBook from '@/components/AddressBook/indexExpand';
  import {queryBusinessNumberList, insertBusinessNumber, deleteBusinessNumber} from '@/api/dealerManage'

  export default {
    name: "dealerManageUserList",
    components: {
      AddressBook
    },
    data() {
      return {
        dealerId: this.$route.query.dealerId,
        sexList: ['未知', '男', '女'],
        configData: {
          title: '选择用户范围',
          depart: {target: 'user', departType: 't', userTypes: '1'},
        },
        addressData: {},
        selectDealerList: [],
        dataList: []
      }
    },
    watch: {
      addressData(addressData) {
        if (addressData.departJson.length || addressData.userJson.length || addressData.groupJson.length) {
          const userList = addressData.userJson.map(item => item.id) || [];
          if (userList.length) {
            insertBusinessNumber({businessId: this.dealerId, userIds: userList.toString()}).then(data => {
              this.queryBusinessNumberList();
              this.$message.success('用户添加成功！');
            })
          } else {
            this.$message.error('请选择用户！');
          }
        } else {
          this.$message.error('请选择用户！');
        }

      }
    },
    created() {
      this.queryBusinessNumberList();
    },
    mixins: [windowResize],
    methods: {
        isShowByPermission,
      goBack() {
        this.$router.go(-1);
      },
      queryBusinessNumberList() {
        queryBusinessNumberList({businessId: this.dealerId}).then(data => {
          this.dataList = data;
        })
      },
      // 删除
      selectionChangeHandler(selection) {
        this.selectDealerList = selection.map(item => item.userId);
      },
      deleteHandler(id) {
        this.$confirm("确认要移出当前用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteBusinessNumber({businessId: this.dealerId, userIds: id}).then(() => {
            this.$message.success('移出成功！');
            this.queryBusinessNumberList();
          })
        });
      },
      deleteSelectHandler() {
        if (!this.selectDealerList.length) {
          this.$message.warning('请选择需要移出的用户！');
          return;
        }
        this.$confirm("确认要移出所选用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteBusinessNumber({businessId: this.dealerId, userIds: this.selectDealerList.toString()}).then(() => {
            this.$message.success('移出成功！');
            this.queryBusinessNumberList();
          })
        });
      },
    }
  }
</script>

<style lang="scss">
  .dealer_manage_list{
    padding: 10px 15px;

    .header {
      padding-bottom: 10px;
      .header_right_btn{
        float:right;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/dealer/dealerManageUserList.vue